import * as types from "../constants/actionTypes";
import * as tools from "../helpers/Tools";

export const epicInitialState = {
    departmentList: null,
    loadingDepartmentList: false,
    providerAppointments: null,
    providerDepartments: null,
    loadingProviderAppointments: false,
    loadingSameDayCareAppointments: false,
    sameDayCareAppointments: null,
    isProviderAppointmentsSuccess: false,
    isSDCAppointmentsSuccess: false,
    isProviderAppointmentsFailure: false,
    isSDCAppointmentsFailure: false
};

export default function epicReducer(state = epicInitialState, action) {
    switch (action.type) {

        case types.LOGOUT:
            return tools.deepCopy(epicInitialState);

        case types.EPIC_PROVIDER_APPOINTMENTS_GET_START:
            if (action.isSameDayCare) {
                return { ...state, loadingSameDayCareAppointments: true };
            }
            else {
                return { ...state, loadingProviderAppointments: true };
            }
        case types.EPIC_PROVIDER_APPOINTMENTS_GET_END:
            if (action.isSameDayCare) {
                return { ...state, loadingSameDayCareAppointments: false, lastSameDayCareAppointmentsError: action.error };
            }
            else {
                return { ...state, loadingProviderAppointments: false, lastProviderAppointmentsError: action.error };
            }
        case types.SIGNALR_UPDATE_ROOM:
            var { room } = action;
            var oProviderAppoints = state.providerAppointments;
            var oSameDayCareAppoints = state.sameDayCareAppointments;
            var bMatched = false;
            var oAppointment;
            for (var i = 0; i < oProviderAppoints.length; i++) {
                if (oProviderAppoints[i].csnId == room.id) {
                    var translated = tools.appointmentRecord(room, 'ROOM_EMPTY');
                    oProviderAppoints[i] = { ...oProviderAppoints[i], translated };
                    bMatched = true;
                    break;
                }
            }
            if (!bMatched) {
                for (var t = 0; t < oSameDayCareAppoints.length; t++) {
                    if (oSameDayCareAppoints[t].id == room.id) {
                        oSameDayCareAppoints[t] = { ...oSameDayCareAppoints[t], ...room };
                        bMatched = true;
                        break;
                    }
                }
            }
            return { ...state, providerAppointments: oProviderAppoints, sameDayCareAppointments: oSameDayCareAppoints };
        case types.EPIC_PROVIDER_APPOINTMENTS_SET_DATA:
            var oAppointments = action.appointments;
            var oDepartments = [];
            var oFlatAppointments = [];
            // Parse Department List
            //debugger;
            try {
                for (var i = 0; i < oAppointments.length; i++) {
                    var oAppointment = oAppointments[i];
                    if (oAppointment.epicAppointmentDetails) {
                        if (oAppointment.epicAppointmentDetails.departments) {
                            for (var u = 0; u < oAppointment.epicAppointmentDetails.departments.length; u++) {
                                if (!oDepartments.find(d => d.DepartmentName === oAppointment.epicAppointmentDetails.departments[u].name)) {
                                    oDepartments.push({
                                        DepartmentName: oAppointment.epicAppointmentDetails.departments[u].name,
                                        DepartmentIDs: oAppointment.epicAppointmentDetails.departments[u].internalId,
                                        DepartmentCIDs: oAppointment.epicAppointmentDetails.departments[u].cidId
                                    });
                                }
                            }
                        }
                        var translated = tools.appointmentRecord(oAppointment, 'Scheduled');
                        oFlatAppointments.push(translated);
                    }
                }

                // Sort By Date
                if (oFlatAppointments.length > 0) {
                    oFlatAppointments = oFlatAppointments.sort((a, b) => a.apptDateTime - b.apptDateTime);
                }

            }
            catch (E) {
                console.error(E);
            }


            //    {
            //        csnId: "74000071927",
            //            patientName: "Chelsea Sattler",
            //                apptTime: "1:15 PM",
            //                    status: "Room Empty",
            //                        deptName: "TENC Family Medicine",
            //                            providerName: "Christopher Stuart",
            //                                staffName: "",
            //                                    reasonforVisit: "I've had a fever on and off for the last couple of days.",
            //                                        disabled: false
            //    }
            //];
            if (action.isSameDayCare) {
                return { ...state, sameDayCareAppointments: oFlatAppointments, isSDCAppointmentsSuccess: true };
            }
            else {
                return { ...state, providerAppointments: oFlatAppointments, providerDepartments: oDepartments, isProviderAppointmentsSuccess: true };
            }
        case types.EPIC_PROVIDER_APPOINTMENTS_GET_FAILURE:
            if (action.isSameDayCare) {
                return { ...state, isSDCAppointmentsFailure: true };
            }
            else {
                return { ...state, isProviderAppointmentsFailure: true };
            }
        case types.SAME_DAY_CARE_APPOINTMENTS_GET_START:
            return { ...state, loadingSameDayCareAppointments: true };
        case types.SAME_DAY_CARE_APPOINTMENTS_GET_END:
            return { ...state, loadingSameDayCareAppointments: false };
        case types.SAME_DAY_CARE_APPOINTMENTS_GET_FAILURE:
            return { ...state, isSDCAppointmentsFailure: true }
        case types.SAME_DAY_CARE_APPOINTMENTS_SET_DATA:
            var oAppointments2 = action.appointments;
            var oFlatAppointments2 = [];
            // Parse Department List
            //debugger;
            try {
                for (var i2 = 0; i2 < oAppointments2.length; i2++) {
                    var oAppointment2 = oAppointments2[i2];
                    if (oAppointment2.epicAppointmentDetails) {
                        var translated = Tools.appointmentRecord(oAppointment2, 'Scheduled');
                        oFlatAppointments2.push(translated);
                    }
                }
                oFlatAppointments2 = oFlatAppointments2.sort((a, b) => a.apptDateTime - b.apptDateTime);

            }
            catch (E) {
                console.error(E);
            }

            return { ...state, sameDayCareAppointments: oFlatAppointments2, isSDCAppointmentsSuccess: true };

        case types.EPIC_DEPT_LIST_GET_START:
            return { ...state, loadingDepartmentList: true };
        case types.EPIC_DEPT_LIST_GET_END:
            return { ...state, loadingDepartmentList: false, lastLoadingDepartmentsError: action.error };
        case types.EPIC_DEPT_LIST_SET_DATA:
            return { ...state, departmentList: action.departmentList, loadingDepartmentList: false };

        default: return { ...state };
    }
}